<template>

  <t-page>


    <t-page-list :title="t('list-of') + currentPage.pageTitle" :user-auth="userAuth"
                 :total-pages="request.totalPages" :total-elements="request.totalElements" @getPage="getPage"
                 :breadcrumb="breadcrumb">


      <template #search>

        <t-button v-if="userAuth.validation.validationCreate" :text="t('insert') + ' ' + currentPage.singularTitle"
                  :to="currentPage.name + '-form-new'" primary/>

        <t-content-header-search-default @searchChange="searchDefault"
                                         @onClearSearch="clearSearch()"
                                         :fields-custom="entityFieldCustomized('page')"
                                         :filtered-default="filteredDefault" :filtered-advanced="filteredAdvanced"
                                         :search-form="form"/>

      </template>


      <t-table :show="checkViewListTableDefault()" @reload="reloadPageList()"
               :filtered="checkIsFiltered()"
               :busy="!pageListIsLoaded"
               :items="request.content"
               :user-auth="userAuth"
               :fields="userAuth.viewFields"
               link-primary-column="name"
               primary-key-column="complementNumber"/>

    </t-page-list>

  </t-page>

</template>
<script>
import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageListMixin from "@/mixins/page/pageListMixin"

export default {
  mixins: [pageDefaultMixin, pageListMixin],
  name: 'Complement',
  data() {
    return {
      path: "", //Utilizar somente quando fora do padrão
      enableGeneralFields: true,
      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela


      //--------------------------------------------------------------------------------------
    }
  },
  methods: {

    mountedPrepare() {

      this.breadcrumb = [
        {text: 'Configurações', to: {name: 'product-setting'}},
      ]

    },
    async mountedContinued() {


    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela


    //--------------------------------------------------------------------------------------

  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedList()

    await this.mountedContinued()

  },
}
</script>
